import * as React from "react";
const SvgFiRrHashtagLock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-hashtag-lock_svg__a)">
      <path d="M9 15h-.79l.721-6h4.152c.293 0 .565-.126.776-.329A5.96 5.96 0 0 1 18 7.001c1.771 0 3.36.775 4.46 2H23a1 1 0 0 0 0-2h-4.946l.707-5.883A1 1 0 0 0 16.777.88L16.042 7H9.171l.707-5.88A1 1 0 1 0 7.892.88l-.735 6.12H1.831a1 1 0 0 0 0 2h5.086l-.721 6H1a1 1 0 0 0 0 2h4.956l-.707 5.88a1 1 0 0 0 .874 1.112c.577 0 1.051-.366 1.112-.874L7.97 17H9a1 1 0 0 0 0-2M18 20.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
      <path d="M22 14.556V13c0-2.206-1.794-4-4-4s-4 1.794-4 4v1.556c-1.19.694-2 1.97-2 3.444v2c0 2.206 1.794 4 4 4h4c2.206 0 4-1.794 4-4v-2c0-1.474-.81-2.75-2-3.444M16 13c0-1.103.897-2 2-2s2 .897 2 2v1h-4zm6 7c0 1.103-.897 2-2 2h-4c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h4c1.103 0 2 .897 2 2z" />
    </g>
    <defs>
      <clipPath id="fi-rr-hashtag-lock_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHashtagLock;
